<template>
    <v-navigation-drawer expand-on-hover rail permanent style="max-width: fit-content;">


        <div class="div_image">
            <v-img src="/logo.png" style="max-width: 5vw;"></v-img>
        </div>


        <v-divider></v-divider>

        <template v-if="user">
            <v-list slim density="compact">
                <v-list-item prepend-icon="mdi-account" class="list-style" :title="user.name" value="login"
                    variant="plain" :active="true" color="primary" @click="show_dialog('user')">


                </v-list-item>
            </v-list>

            <v-divider></v-divider>
        </template>


        <v-list density="compact" nav open-strategy="single" slim variant="plain">
            <template v-for="item in menuItems">
                <v-list-item :key="item.value" :class="{ 'text-disabled': item.disabled }" v-if="item.condition"
                    :prepend-icon="item.icon" :title="item.title" :value="item.value" class="list-style"
                    @click="handleClickMenuItems(item.action, item.disabled);" :active="true" color="primary">
                    <v-tooltip v-if="item.disabled" activator="parent" color="primary">This menu is disabled while a
                        mission is in progress.</v-tooltip>

                </v-list-item>
            </template>


        </v-list>

        <v-divider></v-divider>

        <v-list density="compact" nav slim variant="plain" select-strategy="independent" color="primary">
            <v-list-item v-for="item in routeItems" :key="item.value" class="list-style"
                :class="{ 'list-non-active-style': !activeInfoValues.includes(item.value) }" :prepend-icon="item.icon"
                :title="item.title" :value="item.value" @click="handleInfoButtons(item)">
            </v-list-item>
            <v-list-item prepend-icon="mdi-information-box-outline" title="Vehicle Info" class="list-style"
                :class="{ 'list-non-active-style': !showVehicleInfo }" :active="showVehicleInfo"
                @click="emit('showInfo')" color="primary" />
        </v-list>

        <v-divider></v-divider>



        <v-list density="compact" nav slim variant="plain" select-strategy="single-leaf" color="primary">
            <v-list-item class="list-style" prepend-icon="mdi-layers-triple" value="layers" title="Layers" :active=true>
                <v-menu activator="parent" location="end" :close-on-content-click="false" width="max-content">
                    <v-list density="compact" slim nav>
                        <v-list-item v-for="layerButton of layersButtons">
                            <v-checkbox-btn v-model="layersArray" :label="layerButton.label" :value="layerButton.value"
                                color="primary"></v-checkbox-btn>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-list-item>
        </v-list>


    </v-navigation-drawer>
    <v-navigation-drawer v-model="show_admin_panel" temporary location="right">
        <v-list color="primary" density="compact" nav open-strategy="single" lines="two" slim variant="plain"
            class="list-style">
            <v-list-item prepend-icon="mdi-sail-boat" :active=true @click="show_dialog('vehicles')" title="Vehicles"
                value="vehicles">
            </v-list-item>

            <v-list-item prepend-icon="mdi-compass" :active=true @click="show_dialog('missions')" title="Missions"
                value="missions"></v-list-item>

            <v-list-item v-if="user?.isAdmin" prepend-icon="mdi-account-group" :active=true
                @click="show_dialog('users')" title="Users" value="users"></v-list-item>

            <v-list-item v-if="user?.isAdmin" prepend-icon="mdi-file-multiple" :active=true
                @click="router.push('/admin/csvFiles')" title="CSV Files" value="csv"></v-list-item>

            <!-- <v-list-item v-if="isAdmin" prepend-icon="mdi-lock" :active=false @click="show_dialog('rols')" title="Roles"
                value="rols"></v-list-item> -->

        </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="show_search_panel" temporary location="right" :width="400">
        <slot></slot>
    </v-navigation-drawer>



    <v-overlay v-model="dialog" location="top" style="justify-content:center;align-items: center;">
        <AdminVehiclesPage @close="dialog = false" v-if="overlay_types.vehicles" :user_perms="user_perms">
        </AdminVehiclesPage>
        <AdminMissionsPage @close="dialog = false" v-if="overlay_types.missions" :user_perms="user_perms">
        </AdminMissionsPage>
        <AdminUsersPage @close="dialog = false" v-if="overlay_types.users" :user_perms="user_perms"></AdminUsersPage>
        <AdminRolsPage v-if="overlay_types.rols" :user_perms="user_perms"></AdminRolsPage>
        <EditUserForm v-if="overlay_types.user" :user="user" :upgradable="false" @close="dialog = false"></EditUserForm>
        <InfoModal v-if="overlay_types.info" :isAdmin="user?.isAdmin"></InfoModal>
    </v-overlay>

    <v-btn color="primary" icon="mdi-information-variant" class="info-button-top" density="comfortable"
        @click="show_dialog('info')" v-if="!hideButton"></v-btn>
</template>
<script setup>
import { ref, watch, onMounted, computed, defineProps } from 'vue';
import AdminVehiclesPage from '@/views/admin/Vehicles.vue';
import AdminMissionsPage from '@/views/admin/Missions.vue';
import AdminUsersPage from '@/views/admin/Users.vue';
import AdminRolsPage from '@/views/admin/Roles.vue';
import InfoModal from './InfoModal.vue'
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/userStore';
import router from '@/router';
import { usePlayMissionStore } from '@/store/playMission';
import EditUserForm from './admin/forms/EditUserForm.vue';

const emit = defineEmits(['showLogin', 'showRoutes', 'showNextWaypoint', 'showWaypoints', 'showWind', 'layers', 'showInfo']);
const props = defineProps(['hideButton', 'showVehicleInfo']);
const userStore = useUserStore();
const playMission = usePlayMissionStore();
const { missions } = storeToRefs(playMission);
const { user } = storeToRefs(userStore)
const layersArray = ref([]);
const overlay_types = ref(
    {
        vehicles: false,
        missions: false,
        users: false,
        rols: false,
        info: false,
        user: false
    }
);
const show_vehicle_overlay = ref(false);
const show_admin_panel = ref(false);
const show_search_panel = ref(false);
const dialog = ref(false);
const logout = () => {
    localStorage.clear();
    location.reload();
};

const active = (panel) => {
    show_admin_panel.value = panel === "admin";
    show_search_panel.value = panel !== "admin";
}
const perms = localStorage.getItem('perms');
const user_perms = perms ? JSON.parse(perms) : [];

const show_dialog = (overlay_type) => {
    Object.keys(overlay_types.value).forEach(key => {
        overlay_types.value[key] = false;
    });
    overlay_types.value[overlay_type] = true;
    dialog.value = true;
}

const menuItems = computed(() => [
    { icon: "mdi-account", title: "Log in", value: "login", condition: !user.value, action: () => emit('showLogin') },
    { icon: "mdi-logout", title: "Log out", value: "logout", condition: !!user.value, action: () => logout() },
    { icon: "mdi-cogs", title: "Manage", value: "settings", condition: !!user.value, action: () => active('admin'), disabled: missions.value.length != 0 },
    { icon: "mdi-magnify", title: "Search", value: "search", condition: true, action: () => active('search') }
]);

const routeItems = [
    { icon: "mdi-map-marker-path", title: "Route", value: "route", emit: "showRoutes" },
    { icon: "mdi-map-marker-distance", title: "Active waypoint", value: "next-waypoint", emit: "showNextWaypoint" },
    { icon: "mdi-map-marker-multiple", title: "Waypoints", value: "waypoints", emit: "showWaypoints" },
    { icon: "mdi-weather-windy", title: "Wind", value: "wind", emit: "showWind" }
];

const layersButtons = [
    { label: "Bathymetric contours", value: "Bathymetric contours" },
    { label: "High Resolution bathymetry", value: "High Resolution bathymetry" },
    { label: "Mean depth in multi colour (no land)", value: "Mean depth in multi colour (no land)" },
    { label: "Mean depth rainbow colour (no land)", value: "Mean depth rainbow colour (no land)" }
];


const depthsOptions = {
    1: { name: 'showDepthContour', activated: false },
    2: { name: 'showMarineProfile', activated: false }
}

const handleClickMenuItems = (action, disabled) => {
    if (!disabled) {
        action();
    }
}

const activeInfoValues = ref([]);

function handleInfoButtons(item) {
    const index = activeInfoValues.value.indexOf(item.value);
    if (index === -1) {
        activeInfoValues.value.push(item.value);
    } else {
        activeInfoValues.value.splice(index, 1);
    }

    if (item.emit) emit(item.emit);
}

const showDepths = (emitOption) => {
    const otherOption = emitOption === 1 ? 2 : 1;
    if (!depthsOptions[emitOption].activated && !depthsOptions[otherOption].activated) {

        depthsOptions[emitOption].activated = true;
        emit(depthsOptions[emitOption].name);
        return;

    }

    if (depthsOptions[emitOption].activated) {
        depthsOptions[emitOption].activated = false;
        emit(depthsOptions[emitOption].name);
        return;
    }

    depthsOptions[emitOption].activated = true;
    depthsOptions[otherOption].activated = false;

    emit(depthsOptions[emitOption].name);
    emit(depthsOptions[otherOption].name);
}

onMounted(() => {
    //userName.value = localStorage.getItem("user");
    useUserStore().getActiveUser();
})

watch(layersArray, () => {
    emit('layers', layersArray.value);
});
</script>
<style scoped>
.info-button-top {
    top: 20px;
    right: 10px;
    position: absolute;
    z-index: 1000;
}

.info-button-bottom {
    bottom: 20px;
    right: 10px;
    position: absolute;
    z-index: 1000
}

.opacity-0 {
    opacity: 0;
}

.div_image {
    display: flex;
    justify-content: center;
    margin: 5px;
}

.list-style {
    color: rgb(var(--v-theme-primary)) !important;
    opacity: 1;
    font-weight: 500;
}

.list-non-active-style {
    opacity: 0.38 !important;
}

.text-disabled {
    opacity: 0.38 !important;
}
</style>